import { memo } from 'react';

import type { Offer } from '@/interfaces';

export type StarRatingProps = Pick<Offer, 'rating'> & {
    id: string;
    bigStars?: boolean;
    emptyStars?: boolean;
};

const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));
const toHalfStep = (n: number) => Math.round(n * 2) / 2;

export const StarRating = memo(({ id, rating, bigStars = false, emptyStars = false }: StarRatingProps) => {
    const norm = toHalfStep(clamp(rating, 0, 5));
    const full = Math.floor(norm);
    const hasHalf = norm % 1 === 0.5;

    const starVariant = (i: number): 'StarFull' | 'StarHalf' | 'StarEmpty' => {
        if (i < full) return 'StarFull';
        if (i === full && hasHalf) return 'StarHalf';
        return 'StarEmpty';
    };

    return (
        <div id={id} className="flex flex-row s-text-link gap-4" data-testid="starRatingContainer">
            <span className="sr-only">{norm} stjerners hotell</span>
            {Array.from({ length: 5 }, (_, i) => (
                <w-icon
                    name={starVariant(i)}
                    size={bigStars ? 'medium' : 'small'}
                    locale="nb"
                    key={`${id}-star-${i + 1}`}
                    data-testid="starRating"
                    aria-hidden
                    className={(!emptyStars && starVariant(i)) === 'StarEmpty' ? 'hidden' : undefined}
                />
            ))}
        </div>
    );
});
